import script from "./PastorInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./PastorInfo.vue?vue&type=script&setup=true&lang=js"

import "./PastorInfo.vue?vue&type=style&index=0&id=6ea2df10&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ea2df10"]])

export default __exports__